module.exports = __webpack_public_path__ + "media/Images/TPA-home-banner-6425238a46c73626a5c250070e660c57.jpg";